import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, CheckCircle } from "lucide-react";
import glovisLogo from './Glovis Logo_page-0001.jpg';
import dizzeeLogo from './Dizzee Logo_page-0001.jpg';
import carefinLogo from './Carefin_page-0001.jpg';
import wildArmyLogo from './PHOTO-2025-08-04-14-09-20.jpg';

const BrandPage = () => {
  return (
   <section className="pt-32 pb-16 sm:pt-28 sm:pb-16 lg:pt-32 lg:pb-20 xl:pt-36 xl:pb-24 bg-gradient-to-br from-gray-50 via-white to-blue-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-left mb-8 sm:mb-12 lg:mb-16">
            {/* <span className="inline-block px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-blue-50 text-blue-800 text-sm font-medium mb-6 border border-blue-200/50 shadow-sm">
              OUR PORTFOLIO
            </span> */}
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Our <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-orange-500">Renowned Brands</span>
            </h2>
            <div className="w-24 h-2 bg-gradient-to-r from-blue-600 to-orange-500 rounded-full mb-8 transform group-hover:scale-x-110 origin-left transition-all duration-500"></div>
            <p className="text-xl text-gray-600 leading-relaxed max-w-2xl">
              With an extensive manufacturing, marketing, and distribution network, we bring world-class products under renowned brands that consumers trust worldwide.
            </p>
          </div>

          {/* Brands Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 sm:mb-12 lg:mb-16">
            {[
              { 
                name: 'Glovis', 
                route: 'glovis',
                image: glovisLogo,
                description: 'Premium detergent liquid, floor cleaner, toilet cleaner.',
                category: 'HOUSEHOLD & HYGIENE',
                markets: 'Premium Quality',
                hasNavigation: true
              },
              { 
                name: 'Dizzee Wash', 
                route: 'dizzee',
                image: dizzeeLogo,
                description: 'High-performance dishwash liquid, hand wash.',
                category: 'HOUSEHOLD & HYGIENE',
                markets: 'High Performance',
                hasNavigation: true
              },
              { 
                name: 'Carefin', 
                route: 'carefin',
                image: carefinLogo,
                description: 'Sanitary napkins and luxury women\'s perfumes.',
         category: 'FEMININE PERSONAL CARE',
                markets: 'Luxury Range',
                hasNavigation: true
              },
              { 
                name: 'Wild Army', 
                route: 'wild-army',
                image: wildArmyLogo,
                description: 'Signature men\'s perfume line.',
                category: 'MEN\'S PERFUMES',
                markets: 'Signature Collection',
                hasNavigation: false,
                comingSoon: true
              }
            ].map((brand, index) => (
    <div key={index} className="group relative h-full">
                <div 
                  className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden relative h-full flex flex-col ${brand.hasNavigation ? 'cursor-pointer' : ''}`}
                  onClick={brand.hasNavigation ? () => window.location.href = `/brand/${brand.route}` : undefined}
                >
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-orange-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                  
                  {/* Brand image container */}
                  <div className="relative mb-6 flex-shrink-0">
                    <div className="h-32 w-full rounded-xl flex items-center justify-center p-4 bg-gradient-to-br from-gray-50 to-white border border-gray-100 relative overflow-hidden">
                      {/* Animated background pattern */}
                      <div className="absolute inset-0 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity duration-300" style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Cpath d='M30 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20zm0 0c0 11.046 8.954 20 20 20s20-8.954 20-20-8.954-20-20-20-20 8.954-20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
                      }}></div>
                      
                      <img 
                        src={brand.image} 
                        alt={`${brand.name} Logo`}
                        className="h-full w-full object-contain max-h-20 rounded-lg group-hover:scale-105 transition-transform duration-300"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="hidden items-center justify-center h-full w-full">
                        <span className="text-base font-semibold text-gray-700 text-center w-full">{brand.name}</span>
                      </div>
                    </div>
                    
                    {/* Category badge */}
                    <div className="absolute -top-2 left-0 right-0 mx-2">
                      <span className="block w-full px-2 py-1 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-medium shadow-md text-center">
                        {brand.category}
                      </span>
                    </div>
                    
                    {/* Coming Soon tag */}
                    {brand.comingSoon && (
                      <div className="absolute -bottom-2 left-0 right-0 mx-2">
                        <span className="block w-full px-2 py-1 rounded-full bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-medium shadow-md text-center">
                          Coming Soon
                        </span>
                      </div>
                    )}
                  </div>
                  
                  {/* Brand content */}
                  <div className="space-y-4 flex-1 flex flex-col">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-900 transition-colors duration-300 text-center">
                      {brand.name}
                    </h3>
                    
                    <p className="text-sm text-gray-600 leading-relaxed flex-1 group-hover:text-gray-700 transition-colors duration-300">
                      {brand.description}
                    </p>
                    
                    <div className="flex items-center justify-between pt-4 mt-auto">
                      <div className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                        <span className="text-xs text-gray-500 font-medium">{brand.markets}</span>
                      </div>
                      
                      {/* View Details Button - Only show for brands with navigation */}
                      {brand.hasNavigation && (
                        <Link to={`/brand/${brand.route}`} className="inline-flex items-center space-x-1 px-3 py-1.5 bg-gradient-to-r from-blue-600 to-orange-500 text-white text-xs font-medium rounded-full hover:from-blue-700 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg">
                          <span>View Details</span>
                          <ChevronRight className="w-3 h-3" />
                        </Link>
                      )}
                    </div>
                  </div>
                  
                  {/* Hover effect border */}
                  <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-blue-200 transition-all duration-300 pointer-events-none"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Network Information */}
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl p-4 sm:p-6 lg:p-8 xl:p-10 border border-gray-100">
            <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 xl:gap-12 items-center">
              <div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 lg:mb-5">
                  Extensive Global Network
                </h3>
                <p className="text-xs sm:text-sm md:text-base lg:text-lg text-gray-600 leading-relaxed mb-3 sm:mb-4 lg:mb-5">
                  Our expertise in supply chain management, product development, and market penetration ensures seamless business operations for our partners.
                </p>
                <div className="space-y-2 sm:space-y-3 lg:space-y-4">
                  <div className="flex items-center space-x-2 sm:space-x-3">
                    <CheckCircle className="h-3 w-3 sm:h-4 sm:w-4 lg:h-5 lg:w-5 text-green-500 flex-shrink-0" />
                    <span className="text-xs sm:text-sm md:text-base text-gray-700">Manufacturing Excellence</span>
                  </div>
                  <div className="flex items-center space-x-2 sm:space-x-3">
                    <CheckCircle className="h-3 w-3 sm:h-4 sm:w-4 lg:h-5 lg:w-5 text-green-500 flex-shrink-0" />
                    <span className="text-xs sm:text-sm md:text-base text-gray-700">Marketing & Distribution</span>
                  </div>
                  <div className="flex items-center space-x-2 sm:space-x-3">
                    <CheckCircle className="h-3 w-3 sm:h-4 sm:w-4 lg:h-5 lg:w-5 text-green-500 flex-shrink-0" />
                    <span className="text-xs sm:text-sm md:text-base text-gray-700">Strategic Partnerships</span>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-br from-orange-50 to-blue-50 rounded-lg sm:rounded-xl p-4 sm:p-6 md:p-8">
                <h4 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 md:mb-4">Partnership Focus</h4>
                <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-4 sm:mb-5 md:mb-6">
                  Guided by a vision for excellence, Panagia Group is committed to forging long-term, mutually beneficial partnerships with super stockists, distributors, and retailers.
                </p>
                <div className="grid grid-cols-3 gap-2 sm:gap-3 md:gap-4 text-center">
                  <div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-orange-600">Super</div>
                    <div className="text-xs sm:text-sm text-gray-600">Stockists</div>
                  </div>
                  <div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-blue-600">Global</div>
                    <div className="text-xs sm:text-sm text-gray-600">Distributors</div>
                  </div>
                  <div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-orange-500">Premium</div>
                    <div className="text-xs sm:text-sm text-gray-600">Retailers</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default BrandPage; 